import { Avatar, Grid, Paper, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { getFilesArchivos } from '../../archivos/HelpersArchivos';

const ListadoParticipantesComponent = () => {
  const eventosStore = Redux.useSelector((state) => state.eventos);

  return (
    <Grid container spacing={1}>
      {eventosStore.activo &&
        eventosStore.activo.participantes.map((el) => {
          return (
            <Paper
              elevation={4}
              sx={{
                p: 2,
                width: '150px',
                mr: 1,
                mb: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Avatar
                alt={el.acceso.usuario.perfil.pnombre}
                sx={{ width: 100, height: 100 }}
                src={getFilesArchivos(el.acceso.usuario.perfil.avatar)}
              />
              <Typography variant="body1" textAlign="center">
                {el.acceso.usuario.perfil.tipoDni}-
                {el.acceso.usuario.perfil.dni}
              </Typography>
              <Typography variant="body1" fontWeight="bold" textAlign="center">
                {el.acceso.usuario.perfil.pnombre}
                <br />
                {el.acceso.usuario.perfil.papellido}
              </Typography>
            </Paper>
          );
        })}
    </Grid>
  );
};

export default ListadoParticipantesComponent;
